<template>
    <div>
        <el-form label-position="left" label-width="100px">
            <el-form-item label="字体颜色：">
                <!--<el-color-picker v-model="data.color"></el-color-picker>-->
                <avue-color v-model="data.color"></avue-color>
            </el-form-item>
            <el-form-item label="标题位置：">
                <!--<el-color-picker v-model="data.color"></el-color-picker>-->
                <el-select v-model="data.dalign" placeholder="分割线标题位置">
                    <el-option
                            v-for="item in aligns"
                            :key="item.label"
                            :value="item.value"
                            :label="item.label">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分割线级别：">
                <el-select v-model="data.dividerlevel" placeholder="分割线级别">
                    <el-option
                    v-for="item in items"
                    :key="item.label"
                    :value="item.value"
                    :label="item.label">
                    </el-option>
                </el-select>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
export default {
  name: 'ConfigDivider',
  props: ['data'],
  data() {
    return {
      items: [{
        label: '一级分割线',
        value: 1
      }, {
        label: '二级分割线',
        value: 2
      }, {
        label: '三级分割线',
        value: 3
      }],
      aligns: [{
        value: 'left',
        label: '居左'
      }, {
        value: 'center',
        label: '居中'
      }]
    }
  },
  methods: {

  },
  watch: {

  }
}
</script>
